import Splide from '@splidejs/splide';

export default class TabsCategoriesSlider {
    constructor() {
        this.tabsSliders = [...document.querySelectorAll('.jsFpTabsSlider')];

        if (this.tabsSliders.length) {
            this.events();
        }
    }

    events() {
        this.tabsSliders.forEach((tabsSlider) =>
            this.initializeTabsSlider(tabsSlider),
        );
    }

    initializeTabsSlider(tabsSlider) {
        // eslint-disable-next-line no-unused-vars
        this.activeSlider = new Splide(tabsSlider, {
            type: 'slide',
            rewind: false,
            arrows: false,
            pagination: false,
            destroy: true,
            drag: 'free',
            gap: '0.4375rem',
            fixedHeight: '7.8125rem',
            fixedWidth: '9.25rem',
            breakpoints: {
                1023: {
                    destroy: false,
                },
            },
        }).mount();
    }
}
